var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalkonDocBigIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 70,
    viewBox: "0 0 42.591 49.401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "security-secure-protection-16-svgrepo-com",
    transform: "translate(-13.582 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2338",
    "data-name": "Path 2338",
    d: "M49.781,43.781H33.89a3.415,3.415,0,0,0-3.405,3.405v3.973A6.178,6.178,0,0,1,24.47,57.4c-4.2,0-6.47-2.27-6.47-6.81V12H42.971a6.83,6.83,0,0,1,6.81,6.81V36.374",
    transform: "translate(-2.418)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2340",
    "data-name": "Path 2340",
    d: "M52.416,40a3.415,3.415,0,0,1,3.405,3.405v4.427c0,3.178-3.065,5.789-6.81,5.789H23.7c3.292-.113,6.016-2.5,6.016-5.335V43.405A3.415,3.415,0,0,1,33.121,40Z",
    transform: "translate(-1.648 3.781)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 11.701,
    height: 11.701,
    transform: "translate(25.864 25.199)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2341",
    "data-name": "Path 2341",
    d: "M35.81,25.675H29v-2.27A3.344,3.344,0,0,1,32.405,20h0a3.344,3.344,0,0,1,3.405,3.405Z",
    transform: "translate(-0.933 -1.26)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalkonDocBigIcon);
export default __webpack_public_path__ + "static/media/falkon-doc-big-icon.a0afa2b62c5a235d503b4d10b33fc4f2.svg";
export { ForwardRef as ReactComponent };